export enum InlineMessageType {
  CRITICAL = 'critical',
  HIGH = 'high',
  WARNING = 'warning',
  INFORMATION = 'information',
  SUCCESS = 'success',
  CONFIRMATION = 'confirmation'
};
